<script lang="ts">
    import { actionApproval } from "../store"
    import Cta from "./CTA.svelte"
    import Modal from "./Modal.svelte"
</script>

{#if $actionApproval}
    <Modal
        show="{true}"
        size="sm"
        on:close="{(e) => {
            actionApproval.set(null)
        }}"
    >
        <div slot="header">{$actionApproval.modalTitle}</div>
        <p>
            {$actionApproval.modalText}
        </p>

        <div
            slot="footer"
            style="display: flex; justify-content: space-between; width: 100%;"
        >
            <Cta
                type="tertiaryButton"
                content="Abbrechen"
                icon="solar_close-circle-outline"
                on:click="{() => {
                    actionApproval.set(null)
                }}"
            />
            <Cta
                type="primaryButton"
                content="Weiter"
                icon="solar_arrow-right-outline"
                on:click="{() => {
                    $actionApproval.callback()
                    actionApproval.set(null)
                }}"
            />
        </div>
    </Modal>
{/if}
